import { render, staticRenderFns } from "./ResturantsFilterMobile.vue?vue&type=template&id=7a2934b9"
import script from "./ResturantsFilterMobile.vue?vue&type=script&lang=js"
export * from "./ResturantsFilterMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports